/* Aylo storefront — scoped behaviour (vanilla, Theme Editor aware). */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var parallaxes = [];
  var stepSections = [];
  var bound = false;

  function initReveals(root) {
    var els = root.querySelectorAll('.aylo-reveal:not([data-aylo-ready]), .aylo-stagger:not([data-aylo-ready])');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      els.forEach(function (el) { el.setAttribute('data-aylo-ready', ''); io.observe(el); });
    } else {
      els.forEach(function (el) { el.setAttribute('data-aylo-ready', ''); el.classList.add('is-in'); });
    }
  }

  function parallax() {
    var vh = window.innerHeight || 1;
    parallaxes.forEach(function (el) {
      if (!document.body.contains(el)) return;
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / (vh + r.height);
      var img = el.querySelector('img');
      if (img) img.style.transform = 'scale(1.08) translateY(' + (p * -40) + 'px)';
    });
  }

  function initParallax(root) {
    root.querySelectorAll('[data-aylo-parallax]:not([data-aylo-ready])').forEach(function (el) {
      el.setAttribute('data-aylo-ready', '');
      if (!reduce) parallaxes.push(el);
    });
    parallax();
  }

  function updateSteps() {
    var vh = window.innerHeight || 1;
    stepSections.forEach(function (s) {
      if (!document.body.contains(s.section)) return;
      var best = 0, bestD = Infinity;
      s.steps.forEach(function (st, i) {
        var r = st.getBoundingClientRect();
        var d = Math.abs(r.top + r.height / 2 - vh * 0.5);
        if (d < bestD) { bestD = d; best = i; }
      });
      s.steps.forEach(function (st, i) { st.classList.toggle('is-active', i === best); });
      if (s.bar) s.bar.style.width = ((best + 1) / s.steps.length * 100) + '%';
      if (s.counter) s.counter.textContent = (s.counter.getAttribute('data-label') || 'STEP') + ' ' + (best + 1) + ' / ' + s.steps.length;
    });
  }

  function initSteps(root) {
    root.querySelectorAll('.aylo-steps:not([data-aylo-ready])').forEach(function (section) {
      section.setAttribute('data-aylo-ready', '');
      var steps = Array.prototype.slice.call(section.querySelectorAll('.aylo-step'));
      if (!steps.length) return;
      stepSections.push({ section: section, steps: steps, bar: section.querySelector('.aylo-steps__progress i'), counter: section.querySelector('.aylo-steps__counter') });
    });
    updateSteps();
  }

  function initFaq(root) {
    root.querySelectorAll('.aylo-faq__item:not([data-aylo-ready])').forEach(function (d) {
      d.setAttribute('data-aylo-ready', '');
      var body = d.querySelector('.aylo-faq__body');
      var summary = d.querySelector('summary');
      if (!body || !summary) return;
      body.style.transition = 'height .45s cubic-bezier(.22,.61,.36,1)';
      summary.addEventListener('click', function (ev) {
        if (reduce) return;
        ev.preventDefault();
        if (d.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.height = '0px'; });
          body.addEventListener('transitionend', function h() { d.open = false; body.style.height = ''; body.removeEventListener('transitionend', h); });
        } else {
          d.open = true;
          var hgt = body.scrollHeight;
          body.style.height = '0px';
          requestAnimationFrame(function () { body.style.height = hgt + 'px'; });
          body.addEventListener('transitionend', function h() { body.style.height = ''; body.removeEventListener('transitionend', h); });
        }
      });
    });
  }

  function initQty(root) {
    root.querySelectorAll('.aylo-qty:not([data-aylo-ready])').forEach(function (q) {
      q.setAttribute('data-aylo-ready', '');
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.getAttribute('data-dir') === 'up' ? 1 : -1;
          input.value = Math.max(1, v);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* Variant select → price + availability + hidden id */
  function initVariants(root) {
    root.querySelectorAll('.aylo-product[data-variants]:not([data-aylo-ready])').forEach(function (p) {
      p.setAttribute('data-aylo-ready', '');
      var variants;
      try { variants = JSON.parse(p.getAttribute('data-variants')); } catch (e) { return; }
      var select = p.querySelector('.aylo-variant select');
      var idInput = p.querySelector('input[name="id"]');
      var price = p.querySelector('.aylo-price');
      var compare = p.querySelector('.aylo-compare');
      var btn = p.querySelector('button[name="add"]');
      var fmt = function (cents) { var m = p.getAttribute('data-money') || '£{{amount}}'; return m.replace('{{amount}}', (cents / 100).toFixed(2)).replace('{{amount_no_decimals}}', Math.round(cents / 100)); };
      if (!select) return;
      select.addEventListener('change', function () {
        var v = null;
        for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === select.value) v = variants[i];
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (price) price.textContent = fmt(v.price);
        if (compare) { if (v.compare_at_price && v.compare_at_price > v.price) { compare.textContent = fmt(v.compare_at_price); compare.hidden = false; } else { compare.hidden = true; } }
        if (btn) { btn.disabled = !v.available; var lbl = btn.querySelector('span'); if (lbl) lbl.textContent = v.available ? (btn.getAttribute('data-add') || 'Add to cart') + ' — ' + fmt(v.price) : (btn.getAttribute('data-soldout') || 'Sold out'); }
      });
    });
  }

  function init(root) {
    root = root || document;
    initReveals(root); initParallax(root); initSteps(root); initFaq(root); initQty(root); initVariants(root);
    if (!bound) {
      bound = true;
      /* capture-phase listener: fires for window scroll AND for inner scroll containers (Drive scrolls .page-wrapper on desktop) */
      document.addEventListener('scroll', function () { window.requestAnimationFrame(function () { parallax(); updateSteps(); }); }, { passive: true, capture: true });
      window.addEventListener('resize', updateSteps);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Theme Editor: re-init sections as they load; reveal everything in the editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); e.target.querySelectorAll('.aylo-reveal, .aylo-stagger').forEach(function (el) { el.classList.add('is-in'); }); });
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('DOMContentLoaded', function () { document.querySelectorAll('.aylo-reveal, .aylo-stagger').forEach(function (el) { el.classList.add('is-in'); }); });
  }
  window.AyloInit = init;
})();
